
window.OnServiceReady = function () {

    $("#imgRep").click(function () {
        var idx = 0;//$(this).attr('itemid');
        var val = $('#repairImageUrls').val();
        if (val != "") {
            $.fancybox.open(
                JSON.parse(val)
                , {
                    index: idx,
                    buttons: [
                        'slideShow',
                        'fullScreen',
                        'thumbs',
                        'close'
                    ],}
            );
        }
    });

   
    InitCarrousel();
}

window.InitCarrousel = function () {

    var mainDiv = $("#imgRep");
    
    // Init the detection of the gesture
    //var myElement = document.querySelector('#imgRep');
    //var sliderManager = new Hammer(myElement);
    //sliderManager.add(new Hammer.Pan({ threshold: 10, pointers: 0 }));

    //// listen to events...
    //sliderManager.on("panend", function (ev) {
    //    console.log(ev);
    //    //ev.stopPropagation();
    //});

    var imgCount = mainDiv.data("img-count");

    var bullets = '<ul class="quick-view-bullets">';

    for (var i = 0; i < imgCount; i++) {
        bullets += '<li><a data-index="' + i + '" href="javascript:;"><span>' + (i + 1) + '</span></a></li>';
    }

    bullets += '</ul>';

    $(bullets).insertAfter(mainDiv);

    // Active the first bullet as default
    $(".quick-view-bullets li:first").addClass("active");
    
    $(".quick-view-bullets").on('click', 'a', function () {
        var index = $(this).data('index');

        DisplayImage(imgCount, index);
    })
}

window.DisplayImage = function (imgCount, index) {
    // Active the bullet
    $(".quick-view-bullets li").removeClass("active");
    $(".quick-view-bullets li:eq(" + index + ")").addClass("active");

    // Load the new image
    $(".imgWatch").attr("src", "");
    $(".imgWatch").attr("src", "/Brand/" + $("#brandCode").val() + "/Service/GetRepairImage?width248&height=198&index=" + index);
}


 // Keep this fonction for testing until we implement the service pages
window.DisplayContent = function (e, type, rep, date, path, ext, mime) {

    if (path != undefined && path.indexOf('#') >= 0) {
        if (path != null && path != "" && path != "RET" && path != "CUC" && path != undefined) {
            path = path.replace(/#/g, "\\");
        }
    }

    var key = path;
    if (path == undefined || path == "") {
        key = type
    }

    if (rep === undefined) {
        rep = '';
    }

    if (date === undefined) {
        date = '';
    }
    window.location.href = '/Brand/' + $("#brandCode").val() + '/Service/ShowDocumentContent?key=' + key + '&repairNr=' + rep + '&date=' + date + '&fileExtension=' + ext + '&mimeType=' + mime;
};


